import axios from 'axios';

// const urlDev = process.env.REACT_APP_API_URL

const urlDev = "http://localhost:8000/api/"

const urlProduccion = 'https://www.envasan.com.ar/api/';

export const URLserver = process.env.NODE_ENV === "development" ?
    urlDev
    :
    urlProduccion

const instance = axios.create({
  baseURL: URLserver,
});

export default instance;